import { render } from "./AddMealTutorialDialog.vue?vue&type=template&id=5571e4ac&scoped=true&ts=true"
import script from "./AddMealTutorialDialog.vue?vue&type=script&lang=ts"
export * from "./AddMealTutorialDialog.vue?vue&type=script&lang=ts"

import "./AddMealTutorialDialog.vue?vue&type=style&index=0&id=5571e4ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5571e4ac"]])

export default __exports__